import { Component, ViewChild, ElementRef, Input, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from "rxjs/Observable";
import { getShowSearchControl, getShowSearchBar } from '../../store/store';
import * as thresholdActions from '../../store/actions/actions';

@Component({
    selector: 'celine-threshold-search-bar',
    template: require('./search-bar.component.html')
})

export class SearchBarComponent {
    @Input('mastHeadRef') mastHead: any;

    @ViewChild('searchBar') searchBar: ElementRef;
    @ViewChild('searchOverlay') searchOverlay: ElementRef;
    @ViewChild('searchInput') searchInput: any;
    
    searchPhrase: string;

    showSearchControl$: Observable<boolean>;
    showSearchBar$: Observable<boolean>;

	constructor(
        private store: Store<any>,
        private renderer: Renderer2
    ) {
        this.showSearchControl$ = this.store.select(getShowSearchControl);
        this.showSearchBar$ = this.store.select(getShowSearchBar);

        this.showSearchBar$.subscribe(state => {
            if (state === true) {
                this.renderer.setStyle(document.body, 'overflow', 'hidden');
                setTimeout(() => {
                    let topPosition = this.getSearchBarTopPosition() + '65'; // Add buffer for logo section
                    this.renderer.setStyle(this.searchOverlay.nativeElement, 'top', topPosition + 'px');
                    this.renderer.setStyle(this.searchBar.nativeElement, 'top', topPosition + 'px');
    
                    this.searchInput.formControl.nativeElement.select();
                    this.searchInput.formControl.nativeElement.focus();                
                }, 0)
            }
            else {
                this.renderer.setStyle(document.body, 'overflow', 'auto');
            }                
		});
    }

    toggleSearchBar() {
        this.store.dispatch(new thresholdActions.ToggleSearchBarAction());
    }

	public searchClick() {
        // fire action
        if (this.searchPhrase && this.searchPhrase.trim().length > 0) {
            this.store.dispatch(new thresholdActions.FetchSearchResultsAction(this.searchPhrase));
            this.store.dispatch(new thresholdActions.ToggleSearchBarAction());
            this.renderer.setStyle(document.body, 'overflow', 'auto');            
        }		
    }

    private getSearchBarTopPosition(): number {
        let mastHead = this.mastHead.elRef;

        if (mastHead && mastHead.nativeElement) {
            return mastHead.nativeElement.getBoundingClientRect().height;
        }

        return 0;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/search/search-bar.component.ts